import { resetCpanelToastState } from './cpanelToast';

export const CPANEL_TOKEN_KEY = 'token-cpanel';
export const CENTRAL_USER_KEY = 'central-user';
const LEGACY_CENTRAL_USER_KEY = 'cpanel-user';

export const getCpanelToken = () => localStorage.getItem(CPANEL_TOKEN_KEY);

export const setCpanelToken = (token) => {
  localStorage.setItem(CPANEL_TOKEN_KEY, token);
};

export const clearCpanelToken = () => {
  localStorage.removeItem(CPANEL_TOKEN_KEY);
};

export const getCentralUser = () => {
  try {
    const raw =
      localStorage.getItem(CENTRAL_USER_KEY) ||
      localStorage.getItem(LEGACY_CENTRAL_USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const setCentralUser = (user) => {
  if (user) {
    localStorage.setItem(CENTRAL_USER_KEY, JSON.stringify(user));
    localStorage.removeItem(LEGACY_CENTRAL_USER_KEY);
  }
};

export const clearCentralUser = () => {
  localStorage.removeItem(CENTRAL_USER_KEY);
  localStorage.removeItem(LEGACY_CENTRAL_USER_KEY);
};

export const isCpanelAuthenticated = () => Boolean(getCpanelToken());

export const logoutCpanel = ({ navigate, hardRedirect = false } = {}) => {
  clearCpanelToken();
  clearCentralUser();
  resetCpanelToastState();

  try {
    document.querySelectorAll('.central-user-menu[data-kt-menu="true"]').forEach((menuEl) => {
      const instance = window.KTMenu?.getInstance?.(menuEl);
      instance?.hide?.();
    });
  } catch {
    // ignore Metronic cleanup errors
  }

  if (hardRedirect || typeof navigate !== 'function') {
    const loginPath = '/';
    if (window.location.pathname !== loginPath) {
      window.location.replace(loginPath);
    }
    return;
  }

  navigate('/', { replace: true });
};

export const getCpanelAssetUrl = (path) => {
  if (!path || typeof path !== 'string') return null;
  const trimmed = path.trim();
  if (!trimmed) return null;
  if (/^https?:\/\//i.test(trimmed)) return trimmed;

  const apiBase = (process.env.REACT_APP_API_URL || '/api').replace(/\/$/, '');
  const origin = apiBase.replace(/\/api$/i, '') || '';
  const assetPath = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  return `${origin}${assetPath}`;
};

const CENTRAL_ROLE_LABELS = {
  superadmin: 'Super Admin',
  operator: 'Operator',
};

export const formatCentralRoleLabel = (role) => {
  if (!role || typeof role !== 'string') return null;
  const key = role.trim().toLowerCase();
  return CENTRAL_ROLE_LABELS[key] || role;
};

export const getCentralUserInitials = (user) => {
  const name = (user?.namaLengkap || user?.username || 'A').trim();
  const parts = name.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  }
  return name.slice(0, 2).toUpperCase();
};
